
import React, { useEffect, useState } from "react";
import styles from "../../../src/assets/scss/Billing/InvoiceDesign.module.scss";
import html2canvas from "html2canvas";
import { useLazyGetBillPdfQuery, useGetUserByIdQuery } from "../../slices/admin/admin";
import { BaseURL } from "../../lib/api";
import { getUserInfo } from "../../utils/user.util";

const formatCurrency = (v) => {
    if (v == null) return "₹0.00";
    return "₹" + Number(v).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const formatDate = (iso) => {
    const d = iso ? new Date(iso) : new Date();
    return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

const formatTime = (iso) => {
    const d = iso ? new Date(iso) : new Date();
    return d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: true });
};

const InvoiceDesign = ({ data = {}, mode = "thermal" }) => {

    //console.log(data, "data4646464");

    const localUser = getUserInfo();
    const userId = localUser?._id;

    // Fetch latest user info via API
    const { data: userData } = useGetUserByIdQuery(userId, { skip: !userId });



    // console.log(userData, "userData76786");


    // Store logo state
    const [printerLogo, setPrinterLogo] = useState(null);
    const [printerOption, setPrinterOption] = useState(80); // default 80mm

    useEffect(() => {
        if (userData?.result?.length > 0) {
            const user = userData.result[0];
            // if (user.isPrintLogo && user.store?.logo) {
            //     setPrinterLogo(`${BaseURL}/${user.store?.logo}`);
            // }
            if (user.isPrintLogo && user.store?.logo) {
                const logoPath = user.store.logo.startsWith("http")
                    ? user.store.logo
                    : `${BaseURL.replace(/\/$/, "")}/${user.store.logo.replace(/^\/+/, "")}`;
                setPrinterLogo(logoPath);
            }

            if (user.printerOption) setPrinterOption(user.printerOption);
        }
    }, [userData]);

    console.log(userData, "userData444");


    const items = data.items || [];
    const [triggerGetBillPdf] = useLazyGetBillPdfQuery();

    const subtotal = items.reduce((s, it) => s + (Number(it.price || 0) * Number(it.productQuantity || 0)), 0);
    const paymentMethods = data?.paymentMethod;
    const logistic = Number(data.logisticCharge || 0);
    const handle = Number(data.handleCharge || 0);
    const total = subtotal + logistic + handle;

    // WhatsApp share
    const handleShareWhatsApp = async () => {
        try {
            if (!data._id) return alert("Bill ID not found!");
            const response = await triggerGetBillPdf(data._id).unwrap();

            const pdfUrl = response?.pdfUrl || `${BaseURL}billing/print/${data._id}`;
            const message = `Hi ${data.customer?.firstName || ""}, here is your invoice:\n${pdfUrl}`;
            const waUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
            window.open(waUrl, "_blank");
        } catch (err) {
            console.error("Error sharing PDF:", err);
            alert("Failed to share invoice.");
        }
    };



  //  Thermal Print
    const handlePrint = async () => {
        const invoiceElement = document.getElementById("print-area");
        if (!invoiceElement) return;

        const buttons = invoiceElement.querySelectorAll(".addBtn, .noPrint");
        buttons.forEach((btn) => (btn.style.display = "none"));

        // Wait for images (like logo) to load before capturing
        const images = invoiceElement.querySelectorAll("img");
        await Promise.all(
            Array.from(images).map((img) => {
                if (img.complete) return Promise.resolve();
                return new Promise((resolve, reject) => {
                    img.onload = resolve;
                    img.onerror = resolve;
                });
            })
        );

        const canvas = await html2canvas(invoiceElement, {
            scale: 2,
            useCORS: true,
            allowTaint: true,
            backgroundColor: "#fff",
        });

        const imgData = canvas.toDataURL("image/png");
        buttons.forEach((btn) => (btn.style.display = ""));

        const printWindow = window.open("", "_blank");
        printWindow.document.write(`
    <html>
      <head>
        <title>Invoice</title>
        <style>
          body, html { margin:0; padding:0; background:#fff; }
          img { max-width:100%; height:auto; display:block; margin:auto; }
        </style>
      </head>
      <body>
        <img src="${imgData}" />
        <script>
          window.onload = function() { window.print(); window.onafterprint = function(){ window.close(); } }
        </script>
      </body>
    </html>
  `);
        printWindow.document.close();
    };

// const handlePrint = async () => {
//   const invoiceElement = document.getElementById("print-area");
//   if (!invoiceElement) return;

//   // Hide buttons first
//   const buttons = invoiceElement.querySelectorAll(".addBtn, .noPrint");
//   buttons.forEach((btn) => (btn.style.display = "none"));

//   // Create canvas (same as your code)
//   const images = invoiceElement.querySelectorAll("img");
//   await Promise.all(
//     Array.from(images).map((img) => {
//       if (img.complete) return Promise.resolve();
//       return new Promise((resolve) => {
//         img.onload = img.onerror = resolve;
//       });
//     })
//   );

//   const canvas = await html2canvas(invoiceElement, {
//     scale: 2, // Adjust for thermal printer width (typically 384-576 pixels)
//     useCORS: true,
//     allowTaint: true,
//     backgroundColor: "#fff",
//     width: 384, // 80mm thermal printer width in pixels @ 203dpi
//   });

//   buttons.forEach((btn) => (btn.style.display = ""));

//   // Convert canvas to ESC/POS bytes and print directly
//   await printCanvasToThermal(canvas);
// };

// // Convert canvas to thermal printer raster bytes
// async function printCanvasToThermal(canvas) {
//   if (!navigator.serial) {
//     alert("Web Serial API not supported. Use Chrome/Edge.");
//     return;
//   }

//   try {
//     // User selects USB printer port once
//     const port = await navigator.serial.requestPort();
//     await port.open({ baudRate: 9600, dataBits: 8, stopBits: 1, parity: 'none' });
//     const writer = port.writable.getWriter();

//     // ESC/POS commands: Init + Image + Cut
//     const encoder = new TextEncoder();
    
//     // 1. Initialize printer (ESC @)
//     await writer.write(encoder.encode('\x1B\x40'));
    
//     // 2. Convert canvas to monochrome raster bytes
//     const imageBytes = canvasToEscPosRaster(canvas);
    
//     // 3. Send raster image command (GS v 0)
//     const widthBytes = Math.ceil(canvas.width / 8);
//     const cmd = new Uint8Array([
//       0x1D, 0x76, 0x30, 0x00,  // GS v 0 m
//       widthBytes & 0xFF, (widthBytes >> 8) & 0xFF,  // width in bytes
//       canvas.height & 0xFF, (canvas.height >> 8) & 0xFF  // height
//     ]);
//     await writer.write(cmd);
//     await writer.write(imageBytes);
    
//     // 4. Cut paper
//     await writer.write(encoder.encode('\x1D\x56\x00'));
    
//     writer.releaseLock();
//     await port.close();
//     console.log("Printed directly to thermal printer!");
//   } catch (err) {
//     console.error("Print failed:", err);
//     alert("Printer connection failed. Ensure USB thermal printer is connected.");
//   }
// }

// // Convert canvas to ESC/POS monochrome raster [web:24][web:36]
// function canvasToEscPosRaster(canvas) {
//   const ctx = canvas.getContext('2d');
//   const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
//   const data = imageData.data;
//   const bytes = [];

//   for (let y = 0; y < canvas.height; y++) {
//     let byte = 0;
//     for (let x = 0; x < canvas.width; x += 8) {
//       for (let bit = 0; bit < 8; bit++) {
//         const pxIndex = ((y * canvas.width) + x + bit) * 4;
//         const isBlack = data[pxIndex] < 128 || data[pxIndex + 1] < 128 || data[pxIndex + 2] < 128;
//         if (isBlack) byte |= 1 << (7 - bit);
//       }
//       bytes.push(byte);
//     }
//   }
//   return new Uint8Array(bytes);
// }


    return (
        <div className={styles.overlay}>
            <div className={styles.invoiceBox} id="print-area">
                <div className={styles.header}>
                    {printerLogo ? (
                        // <img
                        //     src={printerLogo}
                        //     alt="Logo"
                        //     className={`${styles.printLogo} ${printerOption === 58 ? styles.logo58 : styles.logo80}`}
                        // />
                        <img
                            src={printerLogo}
                            alt="Logo"
                            onError={(e) => (e.target.style.display = "none")}
                            className={`${styles.printLogo} ${printerOption === 58 ? styles.logo58 : styles.logo80}`}
                        />

                    ) : (
                        <h2></h2>
                    )}

                    {/* Store address below logo */}
                    {userData?.result?.[0]?.store && (
                        <div className={styles.storeInfo}>
                            <div className={styles.storeName}>
                                {userData.result[0].store.storeName}
                            </div>
                            {userData.result[0].store.gst && (
                                <div className={styles.storeAddress}>

                                    <div className={styles.storeGST}>
                                        GST : {userData.result[0].store.gst}
                                    </div>
                                </div>
                            )}


                            <div className={styles.storeAddress}>
                                {[
                                    userData.result[0].store.address,
                                    userData.result[0].store.address1,
                                    userData.result[0].store.city
                                ]
                                    .filter(Boolean)
                                    .join(", ")}
                            </div>
                            <div className={styles.storeAddress}>
                                {[
                                    userData.result[0].store.state,
                                    userData.result[0].store.pincode
                                ]
                                    .filter(Boolean)
                                    .join(" - ")}
                            </div>

                        </div>
                    )}
                    <h2 className={styles.headingtitle}>Sales Bill</h2>

                </div>


                <div className={styles.infoRow}>
                    <div className={styles.left}>
                        {data.customer?.storeName && (
                            <div>
                                <span className={styles.label}>Org Name</span> <span className={`${styles.labels} notranslate`}> : {data.customer.storeName.charAt(0).toUpperCase() + data.customer.storeName.slice(1)}</span>
                            </div>
                        )}
                        <div>
                            <span className={styles.label}>Name</span>{" "}
                            <span className={styles.labelsname}>
                                :{" "}
                                {data.customer?.firstName
                                    ? data.customer.firstName.charAt(0).toUpperCase() + data.customer.firstName.slice(1)
                                    : "-"}
                            </span>
                        </div>

                        <div>
                            <span className={styles.label}>Phone</span>  <span className={`${styles.labels} notranslate`}> : {data.customer?.phone || "-"}</span>
                        </div>
                    </div>
                    {/* <div className={styles.right}>
                        <div>
                            <span className={styles.label}>Bill No</span>  <span className={styles.labels}> : {data.receiptNo || "-"}</span>
                        </div>
                        <div>
                            <span className={styles.label}>Date</span>  <span className={styles.labels}> : {formatDate(data.createdAt)}</span>
                        </div>
                        <div>
                            <span className={styles.label}>Time</span>  <span className={styles.labels}> : {formatTime(data.createdAt)}</span>
                        </div>
                    </div> */}
                </div>
                <hr className={styles.dotted} />
                <div className={styles.infoRow}>
                    <div className={styles.left}>
                        <div>
                            <span className={styles.label}>Bill No</span>  <span className={`${styles.labels} notranslate`}> : {data.receiptNo || "-"}</span>
                        </div>
                        <div>
                            <span className={styles.label}>Date</span>  <span className={`${styles.labels} notranslate`}> : {formatDate(data.createdAt)}</span>
                        </div>
                        <div>
                            <span className={styles.label}>Time</span>  <span className={`${styles.labels} notranslate`}> : {formatTime(data.createdAt)}</span>
                        </div>
                    </div>

                </div>

                <hr className={styles.dotted} />
                {/* <hr className={styles.dottedSmallmargin} /> */}


                <table className={styles.invoiceTable}>
                    <thead>
                        <tr>
                            <th className={styles.itemHeader}>Item Name</th>
                            <th className={styles.qtyHeader}>Quantity</th>
                            <th className={styles.priceHeader}>Price</th>
                            <th className={styles.totalHeader}>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((it, idx) => {
                            const amt = Number(it.price || 0) * Number(it.productQuantity || 0);
                            return (
                                <tr key={idx}>
                                    <td className={styles.itemCell}>
                                        {it.productName
                                            ? it.productName.charAt(0).toUpperCase() + it.productName.slice(1)
                                            : "-"}
                                    </td>
                                    <td className={`${styles.qtyCell} notranslate`}>
                                        {it.productQuantity || 0} {it.productQuality ? `(${it.productQuality})` : ""}
                                    </td>
                                    <td className={`${styles.priceCell} notranslate`}>{formatCurrency(it.price)}</td>
                                    <td className={`${styles.totalCell} notranslate`}>{formatCurrency(amt)}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>

                <hr className={styles.dotted} />
                {/* <hr className={styles.dottedSmallmargin} /> */}

                <div className={styles.summary}>
                    <div className={styles.summaryRow}>
                        <div className={styles.qtys}>Items/Qty :</div>
                        <div className={`${styles.qtys} notranslate`}>{items.length} / {items.reduce((s, it) => s + Number(it.productQuantity || 0), 0)}</div>
                    </div>

                    <div className={styles.totals}>
                        <div className={styles.totalRow}>
                            <div className={styles.fixwidths}><p className={styles.fixwidth}>Payment Type </p> <span> : </span></div>
                            <div className={styles.payable}>{paymentMethods}</div>
                        </div>
                        <div className={styles.totalRow}>
                            <div className={styles.fixwidths}><p className={styles.fixwidth}>Subtotal </p><span> :</span></div>
                            <div className={`${styles.totalAmount} notranslate`}>{formatCurrency(subtotal)}</div>
                        </div>
                        <div className={styles.totalRow}>
                            <div className={styles.fixwidths}> <p className={styles.fixwidth}>Handling Charge  </p><span> : </span></div>
                            <div className={`${styles.totalAmount} notranslate`}>{formatCurrency(handle)}</div>
                        </div>
                        <div className={styles.totalRow}>
                            <div className={styles.fixwidths}> <p className={styles.fixwidth}>Logistic Charge   </p><span> :  </span></div>
                            <div className={`${styles.totalAmount} notranslate`}>{formatCurrency(logistic)}</div>
                        </div>

                        <hr className={styles.dotted} />

                        <div className={styles.totalRow}>
                            <div className={styles.fixwidths}> <p className={styles.fixwidth}>Total Amount  </p><span> : </span></div>
                            <div className={`${styles.grandAmount} notranslate`}>{formatCurrency(total)}</div>
                        </div>
                        <hr className={styles.dotted} />

                        {data.loadHandlerId?.name && (
                            <div className={styles.totalRow}>
                                <div className={styles.fixwidths}> <p className={styles.fixwidth}>Load Handler </p><span> : </span></div>
                                <div className={`${styles.payable} notranslate`}>{data.loadHandlerId.name.charAt(0).toUpperCase() + data.loadHandlerId.name.slice(1)}</div>
                            </div>
                        )}

                        {data.transportPersonId?.name && (
                            <div className={styles.totalRow}>
                                <div className={styles.fixwidths}> <p className={styles.fixwidth}>Transport Person </p><span> : </span></div>
                                <div className={`${styles.payable} notranslate`}>{data.transportPersonId.name.charAt(0).toUpperCase() + data.transportPersonId.name.slice(1)}</div>
                            </div>
                        )}




                    </div>

                    {userData?.result?.[0]?.isTnc && userData?.result?.[0]?.tnc && (
                        <div className={styles.tncSection}>
                            <h4 className={styles.tncHeading}>Terms and Conditions</h4>
                            <p className={styles.tncText}>{userData.result[0].tnc}</p>
                        </div>
                    )}

                    <div className={styles.footer}>
                        {mode === "thermal" && (
                            <button className={`${styles.addBtn} noPrint`} onClick={handlePrint}>Print</button>
                        )}
                        {mode === "whatsapp" && (
                            <button className={styles.addBtn} onClick={handleShareWhatsApp}>Share on WhatsApp</button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvoiceDesign;


